module.exports = __webpack_public_path__ + "static/media/stepCircleDone.6ef5faa6.svg";